import store from "@/store";
import invoiceStoreModule from "../invoiceStoreModule";
import { ref } from '@vue/composition-api';
export default function useInvoicePreview() {
  const STORE_MODULE_NAME = 'invoice';

  // Register module
  if (!store.hasModule(STORE_MODULE_NAME)) {
    store.registerModule(STORE_MODULE_NAME, invoiceStoreModule);
  }
  const draftInvoice = ref('')
  const itemLocal = ref({
    uuid: '',
    id: ''
  })
  const previewUrl = ref()
  const pdfUrl = ref()
  const fetchInvoiceHtml = () => {
    previewUrl.value = `${process.env.VUE_APP_URL}/invoice/preview/${itemLocal.value.id}/${itemLocal.value.uuid}`;
    store
      .dispatch('invoice/previewInvoiceWithUUID',
        itemLocal.value
      )
      .then(response => {
        pdfUrl.value = response.data;
      })
      .catch(error => {
      });
  };

  return {
    draftInvoice,
    itemLocal,
    pdfUrl,
    previewUrl,
    fetchInvoiceHtml
  }
}

